export const paymentFailedStatuses = ["processor_declined", "failed", "voided"];

export const paymentAuthorizedStatus = "authorized";

export const specificErrorCodes = ["saved_payment_method_required"];

export const TransactionFailedErrorType = "transaction_failed";

export const adjustmentTypes = {
  package: "Bundles::BundlePurchase",
  slotVariation: "SlotVariation",
  giftCard: "GiftCardPurchase",
  membership: "Memberships::MembershipPurchase",
  tax: "Pos::TaxItem",
  product: "Pos::SkuItem",
  tip: "Tip",
  sessionEnrollment: "MyClass::SessionEnrollment",
  surchargeItem: "Pos::SurchargeItem",
  cancellationFee: "Purchase::Item::CancellationFee",
  miscItem: "Pos::MiscItem",
};
